module.exports = __webpack_public_path__ + "static/img/404.40d9ee23.svg";